module.exports = __webpack_public_path__ + "media/honey-icons/icon-thumb-down-871a42f8.svg";